import { Dispatch } from "redux";
import { FormattedAxnRelyingParty, AxnCompany } from "@idw-types/data/reference-data/axn";
import { setRelyingParties, setRelyingPartiesLoading } from "@redux/actions/relying-parties-actions";
import { getRelyingPartiesRequest } from "@requests/axnadmin-core";
import { formatRelyingParties } from "@formatters/relying-parties/relying-party-formatter";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getRelyingPartiesReduxRequest = (dispatch: Dispatch) => async (
    companies: Array<AxnCompany>
): Promise<Array<FormattedAxnRelyingParty>> => {
    dispatch(setRelyingPartiesLoading(true));
    const { data, error } = await getRelyingPartiesRequest();
    if (data?.axnRelyingParties) {
        const formattedRelyingParties = formatRelyingParties(data.axnRelyingParties, companies);
        dispatch(setRelyingParties(formattedRelyingParties));
        return formattedRelyingParties;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getRelyingParties.error.title,
                resources.requests.getRelyingParties.error.message
            );   
        }
        dispatch(setRelyingPartiesLoading(false));
        return null;
    }
};